var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal"},[_c('div',{staticClass:"copyright"},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" © "+_vm._s(_vm.year)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"version"},[_c('b',[_vm._v("Version: ")]),_vm._v(" "+_vm._s(_vm.version)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43d20214","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegalFooter.vue
// module id = null
// module chunks = 